import { useMemo } from 'react';
import { Button, useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import Text from 'components/common/Text';
import { observer } from 'mobx-react';
import { AppTheme } from 'styles/theme';
import { useTranslation } from 'react-i18next';
import Question from './Question';
import useDepsContainer from 'hooks/useDepsContainer';

interface QuestionsProps {}

const Questions = (props: QuestionsProps) => {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const styles = useStyles({ ...props, mdDown });
  const { uiStore } = useDepsContainer();
  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);
  const cachedI18n = useMemo(() => i18n, [i18n]);

  const ContactUs = () => {
    return (
      <>
        <Flex
          color={'#E85130'}
          style={{
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '20px',
            textAlign: 'center'
          }}
        >
          {cachedT('StillHaveQuestionOrSuggestion')}
        </Flex>
        <Flex mt={3}>
          <Button
            variant="primary"
            style={{
              background: 'black',
              color: '#FBFBFE',
              textTransform: 'uppercase',
              fontStyle: 'normal',
              fontWeight: '500',
              fontSize: '12px',
              padding: '12px 40px',
              borderRadius: '1rem',
              fontFamily: 'Nohemi'
            }}
            onClick={() => {
              window.open('mailto:support@pumpkin.xyz');
            }}
          >
            {cachedT('ContactUs')}
          </Button>
        </Flex>
      </>
    );
  };

  return (
    <Flex width={'100%'} id={'FAQs'} center column>
      <Flex
        width={'100%'}
        // mb={10}
        ml={mdDown ? 0 : 0}
        mt={mdDown ? 5 : 0}
        center={!mdDown}
        column={mdDown}
        className={mdDown ? styles.titleMd : styles.title}
      >
        <Flex className={styles.titleText}>{cachedT('frequentlyAskedQuestions')}</Flex>
      </Flex>

      <Flex width={'100%'} position={'relative'}>
        <Flex className={styles.bank} style={{ width: mdDown || lgDown ? '100vw' : '60%' }}></Flex>
        <Flex
          className={styles.content}
          width={mdDown || lgDown ? '100vw' : '100%'}
          pb={mdDown || lgDown ? 6 : 18}
          px={mdDown || lgDown ? 6 : 0}
          column={mdDown || lgDown}
        >
          {!mdDown && !lgDown && (
            <Flex width={'40%'} mr={12} mt={24} column>
              <Flex justifyContent={'space-between'} mt={2}>
                <Flex className={styles.textA}>{cachedT('registerWithEmailOrPhone')}</Flex>
                <Flex width={'30%'}></Flex>
              </Flex>
              <Flex justifyContent={'space-between'} mt={14}>
                <Flex width={'30%'}></Flex>
                <Flex className={styles.textB}>{cachedT('CanILogInMyAccountOnADifferentDevice')}</Flex>
              </Flex>
              <Flex justifyContent={'space-between'} mt={14}>
                <Flex className={styles.textA}>{cachedT('IsItSafeToMeetPeopleOnPumpkin')}</Flex>
                <Flex width={'30%'}></Flex>
              </Flex>
              <Flex justifyContent={'space-between'} mt={14}>
                <Flex width={'30%'}></Flex>
                <Flex className={styles.textB}>{cachedT('WhatIfILoseMyPrivateKey')}</Flex>
              </Flex>
              <Flex justifyContent={'space-between'} mt={14}>
                <Flex className={styles.textA}>{cachedT('CanIUsePumpkinAnonymously')}</Flex>
                <Flex width={'30%'}></Flex>
              </Flex>
              <Flex className={styles.textC} bgcolor={'#3B3C45'} color={'white'} mt={14}>
                {cachedT('IDoNotDateButKnowDaters')}
              </Flex>
              <Flex className={styles.textC} bgcolor={'white'} mt={14} column center>
                <ContactUs />
              </Flex>
            </Flex>
          )}
          <Flex flex={1} className={styles.question} px={3} mt={mdDown ? 6 : 18} column>
            <Question question={cachedT('registerWithEmailOrPhone')} awnser={cachedT('privateInfoProtection')} />
            <Question
              question={cachedT('CanILogInMyAccountOnADifferentDevice')}
              awnser={cachedT('YesYouCanLogInOnADifferentDevice')}
            />
            <Question
              question={cachedT('HowCanPumpkinEnsureAbsolutePrivacy')}
              awnser={cachedT('PumpkinEnsuresAbsolutePrivacy')}
            />
            <Question question={cachedT('WhatIfIForgetMyPassword')} awnser={cachedT('IfYouForgetYourPassword')} />
            <Question question={cachedT('WhatIfILoseMyPrivateKey')} awnser={cachedT('LosingPrivateKeyDisadvantage')} />
            <Question
              question={cachedT('AreThereFakePeopleOnPumpkin')}
              awnser={cachedT('FakePeopleExistOnAnySocialNetwork')}
            />
            <Question
              question={cachedT('IsItSafeToMeetPeopleOnPumpkin')}
              awnser={cachedT('MeetingPeopleWithHighReputationLevel')}
            />
            <Question
              question={cachedT('CanIFindASeriousRelationshipOnPumpkin')}
              awnser={cachedT('PumpkinIsTheBestPlaceToMeetPeople')}
            />
            <Question question={cachedT('HowCanIImpressSomeoneILike')} awnser={cachedT('BestWayToImpressSomeone')} />
            <Question
              question={cachedT('HowCanImproveMyPumpkinReputation')}
              awnser={cachedT('ImproveReputationByExploringFunctions')}
            />
            <Question
              question={cachedT('LowReputationLevelChancesWithHighLevelPeople')}
              awnser={cachedT('MoreFunctionExplorationIncreasesReputation')}
            />
            <Question question={cachedT('HowToAvoidSomeoneIDontLike')} awnser={cachedT('NotLikeAndUnmatchToAvoid')} />
            <Question
              question={cachedT('CanIUsePumpkinAnonymously')}
              awnser={cachedT('AnonymousUsageWithSecretPictures')}
            />
            <Question question={cachedT('IDoNotDateButKnowDaters')} awnser={cachedT('WelcomeToJoinPumpkin')} />
            <Question
              question={cachedT('DoINeedPumpkinPointsToGetStarted')}
              awnser={cachedT('NoNeedForPumpkinPointsToStart')}
            />
            <Question
              question={cachedT('WhatIsThePointOfAccumulatingPumpkinPoints')}
              awnser={cachedT('BenefitsOfAccumulatingPumpkinPoints')}
            />
          </Flex>
          {(mdDown || lgDown) && (
            <Flex className={styles.textC} bgcolor={'white'} width={'90%'} mt={6} column center>
              <ContactUs />
            </Flex>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    bank: {
      position: 'absolute',
      width: '60%',
      height: '100%',
      zIndex: '1',
      background: '#18181B'
    },
    content: {
      margin: '0 auto',
      zIndex: '2',
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '1280px'
    },
    question: {
      background: 'white'
    },
    textA: {
      padding: '10px',
      background: 'white',
      color: '#232429',
      fontWeight: '500',
      fontSize: '16px',
      width: '50%',
      flex: 1
    },
    textB: {
      padding: '10px',
      background: '#3B3C45',
      color: 'white',
      fontWeight: '500',
      fontSize: '16px',
      width: '50%',
      flex: 1
    },
    textC: {
      padding: '10px',
      fontWeight: '500',
      fontSize: '16px',
      width: '55%',
      margin: '0 auto'
    },
    title: {
      width: '1280px',
      margin: '0 auto',
      height: '219px',
      background: 'url(/images/home-questions-title-bg.png) left top no-repeat',
      backgroundSize: '559px 477px',
      overflow: 'hidden'
    },
    titleMd: {
      width: '100%',
      margin: '0 auto',
      height: '90px',
      background: 'url(/images/home-questions-title-bg.png) left -80px top no-repeat',
      backgroundSize: '186px 159px',
      overflow: 'hidden'
    },
    titleText: {
      fontFamily: "'Lexend' !important",
      fontStyle: 'normal !important',
      fontWeight: '900 !important',
      fontSize: (props: any) => (props.mdDown ? '32px !important' : '64px !important'),
      lineHeight: (props: any) => (props.mdDown ? '40px !important' : '78px !important'),
      width: (props: any) => (props.mdDown ? 'calc(100% - 32px)' : '100%'),
      letterSpacing: '-1px',
      color: '#18181B',
      textAlign: 'center',
      justifyContent: 'center'
    }
  })
);

export default observer(Questions);
